import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { BaseParams } from 'types/utils'

export function useDeleteOffer() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError

  async function deleteOffer({ id }: BaseParams<{}, 'DELETE'>) {
    const res = await apiClient.delete<undefined>(SNA_PREFIX + `offers/${id}/`)
    return res.data
  }

  return useMutation({
    mutationFn: deleteOffer,
    onSuccess: () => {
      toast.success({ message: t('offerDeleted') })
      queryClient.invalidateQueries({ queryKey: ['offers'] })
    },
    onError // Updated to use useOnError
  })
}
